import React from "react";
import PropTypes from "prop-types";

const ProgressBar = (props) => {
  const { className, value, maxValue = 100 } = props;

  return (
    <div className={className}>
      <progress value={value} max={maxValue} />
      <span>{Math.round(value)} %</span>
    </div>
  );
};

ProgressBar.propTypes = {
  className: PropTypes.string,
  maxValue: PropTypes.number,
  value: PropTypes.number,
};

export default ProgressBar;
